import React, { useState, useEffect } from "react";
import "./SurveyGateModal.scss";

const SurveyGateModal = () => {
  const [open, setOpen] = useState(false);

  // 👇 aparece SIEMPRE que el usuario ingrese (DashboardRouter lo monta)
  useEffect(() => {
    setOpen(true);
  }, []);

  if (!open) return null;

  return (
    <div className="sgm-wrap">
      <div className="sgm-card">
        <div className="sgm-title">¡Nuevo! Ya está disponible AIXBOT 🤖</div>
        <div className="sgm-text">
          Ahora puedes resolver tus dudas en el chat (cursos, pagos, evaluaciones y más).
          Haz clic en el ícono de AIXBOT para empezar.
        </div>

        {/* si quieres imagen */}
        <img className="sgm-img" src="/images/aixbot-pretest.png" alt="AIXBOT" />

        <div className="sgm-actions">
          <button className="sgm-btn" onClick={() => setOpen(false)}>
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default SurveyGateModal;
